import { Route } from '@angular/router';

export const routes: Route[] = [
  // Redireciona raiz para login
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth/entrar',
  },

  // Auth
  {
    path: 'auth',
    loadChildren: () => import('./domains/auth/routes'),
  },

  // Admin
  {
    path: 'admin',
    loadChildren: () => import('./domains/admin/routes'),
  },

  // Execução de pesquisa (público - sem auth)
  {
    path: 'coleta/responder/:modeloPesquisaId',
    loadComponent: () => import('./domains/admin/modules/coleta/execucao-pesquisa/features/execucao-pesquisa'),
  },

  // Coming soon
  {
    path: 'em-breve',
    loadChildren: () => import('./domains/coming-soon/routes'),
  },

  // Rota não encontrada
  {
    path: '**',
    redirectTo: 'admin/404',
  },
];
